"use strict";
/**
 * Runtime open-character instance naming: `{templateName}#{ordinal}`.
 * Authored character template names must not contain `#`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHARACTER_INSTANCE_SEPARATOR = void 0;
exports.makeCharacterInstanceName = makeCharacterInstanceName;
exports.parseCharacterInstanceName = parseCharacterInstanceName;
exports.getCharacterTemplateName = getCharacterTemplateName;
exports.isCharacterInstanceName = isCharacterInstanceName;
exports.authoredCharacterNameContainsForbiddenHash = authoredCharacterNameContainsForbiddenHash;
exports.CHARACTER_INSTANCE_SEPARATOR = '#';
/**
 * Build a session-unique instance name for an open character template.
 * @param ordinal Positive integer (≥ 1).
 */
function makeCharacterInstanceName(templateName, ordinal) {
    const trimmed = templateName.trim();
    if (!trimmed) {
        throw new Error('templateName must be non-empty');
    }
    if (trimmed.includes(exports.CHARACTER_INSTANCE_SEPARATOR)) {
        throw new Error(`templateName must not contain '${exports.CHARACTER_INSTANCE_SEPARATOR}': '${trimmed}'`);
    }
    if (!Number.isInteger(ordinal) || ordinal < 1) {
        throw new Error(`ordinal must be an integer ≥ 1, got ${ordinal}`);
    }
    return `${trimmed}${exports.CHARACTER_INSTANCE_SEPARATOR}${ordinal}`;
}
/**
 * Parse an instance name. Returns null if `name` is not `{template}#{positiveInt}`.
 */
function parseCharacterInstanceName(name) {
    const trimmed = name.trim();
    const sep = exports.CHARACTER_INSTANCE_SEPARATOR;
    const idx = trimmed.indexOf(sep);
    if (idx <= 0) {
        return null;
    }
    if (trimmed.indexOf(sep, idx + 1) !== -1) {
        return null;
    }
    const templateName = trimmed.slice(0, idx);
    const ordinalPart = trimmed.slice(idx + 1);
    if (!templateName || !/^[1-9]\d*$/.test(ordinalPart)) {
        return null;
    }
    return {
        templateName,
        ordinal: Number(ordinalPart)
    };
}
/**
 * Template name for an instance (`Musician#2` → `Musician`), or the name itself if not an instance.
 */
function getCharacterTemplateName(name) {
    const parsed = parseCharacterInstanceName(name);
    return parsed ? parsed.templateName : name.trim();
}
function isCharacterInstanceName(name) {
    return parseCharacterInstanceName(name) !== null;
}
/** Authored `## Characters` names must not include `#` (reserved for instances). */
function authoredCharacterNameContainsForbiddenHash(name) {
    return name.includes(exports.CHARACTER_INSTANCE_SEPARATOR);
}
//# sourceMappingURL=characterInstanceNames.js.map